module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PersonalView.js"));
	}, "PersonalView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PersonalView!./src/pages/Shop/Member/Personal/PersonalView.js
// module id = 952
// module chunks = 438